import { Wrapper, WrapperContainer, PoweredBy, PoweredByText, PoweredByLogo } from './index.view';
import FanzLogo from 'components/Icon/assets/FanzNew.svg';

const Header = () => {
  return (
    <Wrapper>
      <WrapperContainer>
        <PoweredBy>
          <PoweredByText>Powered by</PoweredByText>
          <PoweredByLogo>
            <img src={FanzLogo} alt="Fanz" />
          </PoweredByLogo>
        </PoweredBy>
      </WrapperContainer>
    </Wrapper>
  );
};

export default Header;
